import ContactsListPage from "./ContactsListPage";

export default function ContactsPeople() {
  return <ContactsListPage kind="person" />;
}
